import { BrowserRouter, Route, Switch, useHistory, History } from "react-router-dom";
import { useEffect, ReactNode } from "react";
import routes from "./config";

let navigateResolver: (history: History) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: History;
  }
}

export const navigatePromise = new Promise<History>((resolve) => {
  navigateResolver = resolve;
});

// 导航钩子组件，用于初始化全局导航对象
export const NavigationInitializer = () => {
  const history = useHistory();
  
  useEffect(() => {
    window.REACT_APP_NAVIGATE = history;
    navigateResolver(window.REACT_APP_NAVIGATE);
  }, [history]);
  
  return null;
};

// 路由配置组件
export function AppRoutes() {
  return (
    <BrowserRouter>
      <NavigationInitializer />
      <Switch>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={route.component}
          />
        ))}
      </Switch>
    </BrowserRouter>
  );
}
